import {
  Caption,
  Icon,
  IconCounter,
  TabBarMenuTabType,
  useLocales,
} from "@/lib/main";
import { CSSProperties } from "react";
import { NavLink, useLocation } from "react-router";

type Props = { shoppingCartCount?: number; tab: TabBarMenuTabType };

export default function TabBarTab({ shoppingCartCount, tab }: Props) {
  const l = useLocales();
  const location = useLocation();
  const activeLocationPathname = tab.activeWhenPathMatchesLevel
    ? location.pathname
        .split("/")
        .slice(0, tab.activeWhenPathMatchesLevel + 1)
        .join("/")
    : location.pathname;
  const isActive = tab.activeWhenPathMatches
    ? tab.activeWhenPathMatches === activeLocationPathname
    : tab.to === location.pathname + location.hash;

  const linkStyle: CSSProperties = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "var(--spacing-xs)",
  };

  const iconContainerStyle: CSSProperties = {
    position: "relative",
    height: "24px",
  };

  return (
    <li>
      <NavLink
        className={() => (isActive ? "active" : undefined)}
        style={linkStyle}
        to={tab.to}
      >
        {tab.iconKind === "custom" ? (
          <div style={iconContainerStyle}>
            {isActive ? tab.customIconActive : tab.customIcon}
          </div>
        ) : (
          <div style={iconContainerStyle}>
            {tab.cartCount && shoppingCartCount ? (
              <IconCounter
                count={shoppingCartCount}
                iconColor={isActive ? "brand" : "tertiary"}
                iconName="shopping-cart"
              />
            ) : (
              <Icon
                color={isActive ? "brand" : "tertiary"}
                name={isActive ? tab.iconActive : tab.icon}
                size="xl"
              />
            )}
          </div>
        )}

        <Caption color={isActive ? "brand" : "tertiary"} size="tabbar">
          {l(tab.title)}
        </Caption>
      </NavLink>
    </li>
  );
}
